import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

const initialState = {
  name: "",
  nameError: "",
};

function nameAlreadyExists(name, roles) {
  const foundRole = roles.find(
    role => role.name.toLowerCase() === name.toLowerCase(),
  );
  return Boolean(foundRole);
}

function CreateRoleDialog(props) {
  const {addRole} = props;
  const [{name, nameError}, setState] = useState(initialState);

  const clearState = () => {
    setState({...initialState});
  };

  useEffect(
    () => {
      clearState();
    },
    [props.createDialogShown],
  );

  const setStateValue = (name, value) =>
    setState(prevState => ({...prevState, [name]: value}));

  const onNameChange = e => {
    setStateValue("nameError", "");
    setStateValue("name", e.target.value);
  };
  const validateName = e => {
    if (e.target.value.length === 0) {
      setStateValue("nameError", "You must set role name");
    } else {
      setStateValue("nameError", "");
    }
  };

  const addNewRoleHandler = () => {
    if (
      name.toLowerCase() === "new role" ||
      nameAlreadyExists(name, props.roles)
    ) {
      setStateValue("nameError", "Please specify different role name");
    } else {
      addRole({name});
      props.onHideCreateDialog();
    }
  };

  return (
    <Dialog
      fullWidth
      onClose={props.onHideCreateDialog}
      open={props.createDialogShown}
    >
      <DialogTitle>Create new Role</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          placeholder={"Add role name"}
          label="Role Name"
          helperText={nameError}
          error={Boolean(nameError)}
          value={name}
          onChange={onNameChange}
          onBlur={validateName}
        />
      </DialogContent>
      <DialogActions>
        <Button
          key="create-role-dialog-cancel-button"
          onClick={props.onHideCreateDialog}
        >
          Cancel
        </Button>
        <Button
          key="create-role-dialog-create-button"
          color="primary"
          onClick={addNewRoleHandler}
          disabled={!name.length || Boolean(nameError)}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CreateRoleDialog.propTypes = {
  roles: PropTypes.array.isRequired,
  onHideCreateDialog: PropTypes.func.isRequired,
  createDialogShown: PropTypes.bool.isRequired,
  addRole: PropTypes.func.isRequired,
};

export default CreateRoleDialog;
